import type { ElementType } from 'react';
import { TbArchive, TbPlayerPlay, TbTrash } from 'react-icons/tb';
import BulkActionBar, { BulkActionBarItem } from '../BulkActionBar';
import type { InventoryStatus } from '../../types/inventory';

export type InventoryBulkActionId = 'activate' | 'discontinue' | 'delete';

interface InventoryBulkActionBarProps {
    selectedCount: number;
    /** Statuses of selected items — used to enable Activate vs Discontinue. */
    selectedStatuses: InventoryStatus[];
    onClearSelection: () => void;
    onAction: (actionId: InventoryBulkActionId) => void;
    isLoading?: boolean;
}

const InventoryBulkActionBar = ({
    selectedCount,
    selectedStatuses,
    onClearSelection,
    onAction,
    isLoading = false,
}: InventoryBulkActionBarProps) => {
    const hasActive = selectedStatuses.some((s) => s === 'active');
    const hasDiscontinued = selectedStatuses.some((s) => s === 'discontinued');

    const actions: BulkActionBarItem[] = [];
    if (hasDiscontinued) {
        actions.push({ id: 'activate', label: 'Activate', icon: TbPlayerPlay as ElementType });
    }
    if (hasActive) {
        actions.push({
            id: 'discontinue',
            label: 'Discontinue',
            icon: TbArchive as ElementType,
        });
    }
    actions.push({
        id: 'delete',
        label: 'Delete',
        icon: TbTrash as ElementType,
        danger: true,
    });

    return (
        <BulkActionBar
            selectedCount={selectedCount}
            actions={actions}
            onClearSelection={onClearSelection}
            onAction={(actionId) => onAction(actionId as InventoryBulkActionId)}
            isLoading={isLoading}
        />
    );
};

export default InventoryBulkActionBar;
